import { NgModule } from '@angular/core'
import { AccordionModule } from '@vg-constellation/angular-18/accordion'
import { ButtonModule } from '@vg-constellation/angular-18/button'
import { CheckboxComponent, CheckboxGroupComponent, CheckboxInputComponent, CheckboxModule } from '@vg-constellation/angular-18/checkbox'
import { DropdownComponent } from '@vg-constellation/angular-18/dropdown';
import { IconComponent, IconModule } from '@vg-constellation/angular-18/icon'
import { ModalDialogModule } from '@vg-constellation/angular-18/modal-dialog'
import { PaginationComponent, PaginationModule } from '@vg-constellation/angular-18/pagination';
import { RadioComponent, RadioModule } from '@vg-constellation/angular-18/radio';
import { SearchModule } from '@vg-constellation/angular-18/search'
import { SelectModule } from '@vg-constellation/angular-18/select'
import { SpinnerModule } from '@vg-constellation/angular-18/spinner'
import { SwitchModule } from '@vg-constellation/angular-18/switch'
import { TabsModule } from '@vg-constellation/angular-18/tabs'
import { TooltipModule } from '@vg-constellation/angular-18/tooltip'

const constellationModules = [
  AccordionModule,
  ButtonModule,
  CheckboxModule,
  ModalDialogModule,
  IconModule,
  SpinnerModule,
  SelectModule,
  SwitchModule,
  TabsModule,
  TooltipModule,
  RadioComponent,
  RadioModule,
  CheckboxInputComponent,
  CheckboxComponent,
  CheckboxGroupComponent,
  IconComponent,
  DropdownComponent,
  ModalDialogModule,
  PaginationComponent,
  PaginationModule,
  SearchModule
]

@NgModule({
  imports: [...constellationModules],
  declarations: [],
  providers: [],
  exports: [...constellationModules],
})
export class ConstellationModule {}
